export default {
  overrides: {
    MuiCardMedia: {
      root: {
        backgroundSize: 'contain',
        height: 128
      }
    }
  }
}